<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="clickedField"
    >
      <template v-slot:item.name="{ item }">
        {{ item.playbook.data.name ? item.playbook.data.name : 'N/A' }}
      </template>
    </List>

    <b-modal
      id="executions-output-modal"
      title="Output"
      centered
      hide-footer
      size="lg"
    >
      <textarea
        name="executions-output-modal"
        class="output-area"
        id="executions-output-modal"
        :value="showOutput"
        rows="10"
      ></textarea>
    </b-modal>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'ExecutionsDetail',
  data() {
    return {
      loading: false,
      header: [
        { text: 'servers.roleName', value: 'name', size: '3fr', clicked: true },
        { text: 'servers.ok', value: 'result_ok', clicked: true },
        { text: 'servers.changed', value: 'result_changed', clicked: true },
        {
          text: 'servers.unreachable',
          value: 'result_unreachable',
          clicked: true,
        },
        { text: 'servers.failed', value: 'result_failed', clicked: true },
        { text: 'servers.skipped', value: 'result_skipped', clicked: true },
        { text: 'servers.rescued', value: 'result_rescued', clicked: true },
        { text: 'servers.ignored', value: 'result_ignored', clicked: true },
        {
          text: 'servers.time',
          value: 'last_execution_time',
          size: '2fr',
          clicked: true,
        },
      ],
      data: [],
      pagination: {},
      meta: {},
      showOutput: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `ansible/playbook/${
        this.$route.params.id
      }/executions?include=playbook&position=id|DESC&page=${
        current_page ? current_page : 1
      }`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    clickedField(item) {
      if (item.last_output && item.last_output != 'Unknown') {
        this.showOutput = item.last_output
        this.$bvModal.show('executions-output-modal')
      } else {
        this.$generateToast(this, 'warning', 'Output field is empty.')
      }
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.output-area {
  width: 100%;
  height: 100%;
  outline: none;
  padding-left: 10px;

  &:focus {
    border-radius: 4px;
    border: 1px solid #ccc;
  }
}
</style>
